/**
 * Lädt den Onepager „Kontrakte kalkulieren, Weizenpreise pflegen“ herunter.
 *
 * Steht an zwei Stellen: bei den Marktdaten, wo die Kurse gepflegt werden,
 * und in der Preisfindung, wo mit ihnen gerechnet wird. Beide Male ist die
 * Frage dieselbe — „welchen Kontrakt nehme ich?" —, und beide Male soll die
 * Antwort ohne Umweg über ein Handbuch erreichbar sein.
 *
 * Das PDF-Modul wird erst beim Klick geladen: jsPDF ist gut 300 kB und hat
 * auf dem kritischen Pfad der Seite nichts verloren.
 */

import { useState } from "react";

export function AnleitungKnopf() {
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  async function laden() {
    setLaeuft(true);
    setFehler(null);
    try {
      const { erzeugeAnleitungsPdf, ANLEITUNG_DATEINAME } = await import("./anleitungPdf.js");
      const blob = await erzeugeAnleitungsPdf();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = ANLEITUNG_DATEINAME;
      a.click();
      // Erst nach dem Klick freigeben, sonst bricht der Download in Safari ab.
      setTimeout(() => URL.revokeObjectURL(url), 10_000);
    } catch (e) {
      setFehler(e instanceof Error ? e.message : "Anleitung konnte nicht erzeugt werden.");
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <>
      <button className="knopf schlicht" onClick={() => void laden()} disabled={laeuft}>
        {laeuft ? "Wird erzeugt …" : "Anleitung (PDF)"}
      </button>
      {fehler && <span className="meldung fehler">{fehler}</span>}
    </>
  );
}
